import type { useScrollHintModel } from '@/components/home/components/scroll-hint/scroll-hint.model'

type ScrollHintViewProps = ReturnType<typeof useScrollHintModel>

export function ScrollHintView({ hintText, isVisible }: ScrollHintViewProps) {
  return (
    <div
      className={`fz-scroll-hint${isVisible ? ' fz-scroll-hint--visible' : ''}`}
      aria-hidden="true"
    >
      <svg
        className="fz-scroll-hint__petal"
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth="1.4"
          d="M12 4 L12 17 M12 17 L6.5 11.5 M12 17 L17.5 11.5"
        />
      </svg>
      <span className="fz-scroll-hint__label">{hintText}</span>
    </div>
  )
}
